import { sendEmailModifyProfilation } from "../services/request-manager"


export const modifyProfilation = (idValutation, eText) => {
    return sendEmailModifyProfilation(idValutation, eText)
}